import { GenIcon } from '../helpers/IconBase.es.js';

const ImageFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M6.75 9.75C7.99264 9.75 9 8.74264 9 7.5C9 6.25736 7.99264 5.25 6.75 5.25C5.50736 5.25 4.5 6.25736 4.5 7.5C4.5 8.74264 5.50736 9.75 6.75 9.75Z",
              fill: "#82869E"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M20.9023 18.378L14.9023 7.878C14.8349 7.76449 14.7395 7.67015 14.6253 7.60397C14.5111 7.5378 14.3818 7.502 14.2498 7.5C14.1165 7.50165 13.9861 7.5388 13.8719 7.60761C13.7578 7.67642 13.664 7.77441 13.6003 7.8915L9.63131 15.15L7.33631 12.282C7.25873 12.1819 7.15675 12.1034 7.04014 12.054C6.92352 12.0046 6.79618 11.986 6.67031 12C6.54539 12.0133 6.4258 12.0578 6.32254 12.1293C6.21927 12.2009 6.13564 12.2972 6.07931 12.4095L3.07931 18.4095C3.02096 18.524 2.99302 18.6516 2.99816 18.78C3.0033 18.9084 3.04135 19.0334 3.10866 19.1428C3.17598 19.2523 3.27029 19.3427 3.38256 19.4052C3.49483 19.4677 3.62129 19.5004 3.74981 19.5H20.2498C20.3813 19.5001 20.5105 19.4657 20.6245 19.4002C20.7385 19.3346 20.8333 19.2402 20.8993 19.1265C20.9643 19.0126 20.9987 18.8838 20.9993 18.7526C20.9998 18.6215 20.9664 18.4924 20.9023 18.378Z",
              fill: "#82869E"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "18",
                  height: "18",
                  fill: "white",
                  transform: "translate(3 3)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { ImageFilled };
